<h2 mat-dialog-title>Edit {{ data.day | dayofweek }} availability</h2>
<mat-dialog-content class="availability-card">
  <div *ngIf="starts.length <= 0">
    <mat-form-field appearance="outline" class="unavailable">
      <mat-label>
        {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.UNAVAILABLE' | translate }}
      </mat-label>
      <input matInput disabled />
    </mat-form-field>
  </div>
  <div *ngFor="let start of starts.controls; let i = index" class="interval">
    <forms-time-picker
      class="time-picker"
      [control]="start"
      (hasAnyErrors)="timePickerHasErrors('start', i, $event)"
      appearance="outline"
      label="{{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.EDIT_START' | translate }}"
      placeholder="9:00 AM"
    ></forms-time-picker>
    <span class="spacing"></span>
    <forms-time-picker
      class="time-picker"
      [control]="ends.controls[i]"
      (hasAnyErrors)="timePickerHasErrors('end', i, $event)"
      appearance="outline"
      label="{{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.EDIT_END' | translate }}"
      placeholder="5:00 PM"
    ></forms-time-picker>
    <button mat-icon-button (click)="removeRange(i)">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <button mat-button color="primary" (click)="addRange()" [disabled]="isInvalid()">
    {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.EDIT_ADD_INTERVAL' | translate }}
  </button>
  <mat-error *ngIf="isInvalid()">{{ getValidationError() }}</mat-error>

  <!-- Copy to weekdays checkbox - hide for multihost -->
  <div class="copy-weekdays-section" *ngIf="!data.isMultiHost">
    <mat-checkbox
      [(ngModel)]="copyToWeekdays"
      [matTooltip]="'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.COPY_TO_WEEKDAYS_TOOLTIP' | translate"
    >
      {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.COPY_TO_WEEKDAYS' | translate }}
    </mat-checkbox>
  </div>
  <div *ngIf="this.data.isMultiHost">
    <h3>{{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.COMMON_AVAILABILITY.HEADER' | translate }}</h3>
    <div *ngIf="this.data.availableSlots.length > 0">
      <ul>
        <li *ngFor="let val of this.data.availableSlots">
          {{ val }}
        </li>
      </ul>
    </div>
    <div
      *ngIf="this.data.availableSlots.length === 0"
      [innerHTML]="'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.NO_CALENDAR_AVAILABILITY' | translate"
    ></div>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button color="primary" (click)="close()">
    {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.EDIT_CANCEL' | translate }}
  </button>
  <button mat-raised-button color="primary" [disabled]="isInvalid()" (click)="callbackAndClose()">
    {{ 'MEETING_SCHEDULER.SCHEDULE_SETTINGS.AVAILABILITY.EDIT_SAVE' | translate }}
  </button>
</mat-dialog-actions>
